import { Card, CardBody, Col } from "reactstrap";
import { OutlineAlertTitle } from "../../../../constants";
import { OutlineAlertSubTitle } from "../../../../data/uiKits/Alert";
import DarkOutline from "./DarkOutline";
import LightOutline from "./LightOutline";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const OutlineAlert = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={OutlineAlertTitle} span={OutlineAlertSubTitle} />
        <CardBody>
          <LightOutline />
          <DarkOutline />
        </CardBody>
      </Card>
    </Col>
  );
};
export default OutlineAlert;
